export default "__VITE_ASSET__BXOLcqGD__"